module.exports = {"name":"panlex-translator","version":"0.1.0","private":true,"dependencies":{"material-components-web":"^0.30.0","pnormaldist":"^1.0.1","react":"^16.2.0","react-dom":"16.2.0","react-graph-vis":"^1.0.1","react-scripts":"^1.0.13","shebang-loader":"^0.0.1"},"scripts":{"start":"react-scripts start","build":"react-scripts build","test":"react-scripts test --env=jsdom","eject":"react-scripts eject"},"homepage":"https://apps.panlex.org/translator"}


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 233
// module chunks = 0